import { type AnimationProps, motion } from 'framer-motion';
import { type ForwardedRef, forwardRef } from 'react';

export type MotionOptions = AnimationProps;

const initialMotionOptions: MotionOptions = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.2 },
};

const MotionDiv = (
  {
    children,
    className,
    options = initialMotionOptions,
  }: {
    children: React.ReactNode;
    className?: string;
    options?: MotionOptions;
  },
  ref: ForwardedRef<HTMLDivElement>,
) => {
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={options.initial}
      animate={options.animate}
      exit={options.exit}
      transition={options.transition}
    >
      {children}
    </motion.div>
  );
};

const forwardRefMotionDiv = forwardRef(MotionDiv);

export { forwardRefMotionDiv as MotionDiv };
